import './App';
import { Route, Routes } from 'react-router-dom';
import Main from './Main/Main';
import SignIn from './SignIn/SignIn';
// import SignUp from './SignUp/SignUp';
import { AuthProvider } from './AuthProvider';
import DashboardLayout from './Dashboard/DashboardLayout';
// import DashboardHome from './Dashboard/DashboardHome';
import AuthCheck from './AuthCheck';
// import Groups from './Groups/Groups';
import Group from './Groups/Group';
// import History from './History/History';
import Users from './Users/Users';
import CatchAll from './CatchAll';
import HistoryGroup from './History/HistoryGroup';
import Students from './Students/Students';
import Profile from './Profile/Profile';
import Student from './Students/Student';
import User from './Users/User';
import Classes from './Classes/Classes';
import Class from './Classes/Class';
import ClassProgress from './ClassProgress/ClassProgress';
import ClassOverview from './ClassOverview/ClassOverview';
import Privacy from './Privacy/Privacy';
import UsersManaged from './UsersManaged/UsersManaged';
// import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          <Route index element={<Main />} />
          <Route path="/login" element={<SignIn />} />
          <Route path="/privacy" element={<Privacy />} />
          {/* <Route path="/register" element={<SignUp />} /> */}
          <Route path="/app" element={<AuthCheck />}>
            <Route element={<DashboardLayout />}>
              <Route index element={<Classes />} />
              <Route path="profile" element={<Profile />} />
              <Route path="classes" element={<Classes />} />
              {/* <Route path="groups" element={<Groups />} /> */}
              <Route path="users" element={<Users />} />
              <Route path="users/:userId" element={<User />} />
              <Route path="users/managed" element={<UsersManaged />} />
              <Route path="students" element={<Students />} />
              <Route path="students/:userId" element={<Student />} />
              {/* <Route path="history" element={<History />} /> */}
              <Route path="history/:historyId" element={<HistoryGroup />} />
              <Route path="groups/:groupId" element={<Group />} />
              <Route path="classes/:classId" element={<Class />} />
              <Route path="classes/progress/:classId" element={<ClassProgress />} />
              <Route path="classes/overview/:classId" element={<ClassOverview />} />
            </Route>
          </Route>
          <Route path="*" element={<CatchAll />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;


{/* <Route element={<ProtectedRoute requiredRoles={["admin"]} />}>
  <Route path="students" element={<Students />} />
</Route> */}